var Locality = (function () {

  function _show(id) {
    const modal = ModalConductor.activate(LocalityViewModal, id,
      (localityId) => {
        _showOnMap([localityId]);
      })
    .on('closed', (modalResult) => _refreshTable());
  }

  function _showOnMap(ids) {
    if (ids.length > 0) {
      location.href = Url.map(ObjectTypes.Locality, ids);
    }
  }

  function _refreshTable() {
    $('#LocalityListItemViewModelTable').DataTable().ajax.reload(null, false);
  };

  return {
    show: _show,
    showOnMap: _showOnMap
  };
}())
